import React, { useState } from 'react';
import { User } from 'lucide-react';

const PlayerAvatar = ({ 
  imagen_url,
  imageUrl, // Alternative prop name for compatibility
  nombre_completo,
  name, // Alternative prop name for compatibility
  size = 'md', 
  showName = false,
  className = '',
  fallbackIcon = User 
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  
  // Size configurations
  const sizeClasses = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-8 h-8 text-sm', 
    md: 'w-12 h-12 text-base',
    lg: 'w-16 h-16 text-lg',
    xl: 'w-20 h-20 text-xl',
    '2xl': 'w-24 h-24 text-2xl',
    large: 'w-24 h-24 text-2xl' // Alias for 2xl
  };

  const iconSizeClasses = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-6 h-6', 
    lg: 'w-8 h-8',
    xl: 'w-10 h-10',
    '2xl': 'w-12 h-12',
    large: 'w-12 h-12' // Alias for 2xl
  };

  // Use alternative prop names for compatibility
  const finalImageUrl = imagen_url || imageUrl;
  const finalName = nombre_completo || name;
  
  const sizeClass = sizeClasses[size] || sizeClasses.md;
  const iconSizeClass = iconSizeClasses[size] || iconSizeClasses.md;

  // Get initials from name
  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase())
      .slice(0, 2)
      .join('');
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoading(false);
  };

  const FallbackIcon = fallbackIcon;

  return (
    <div className={`inline-flex flex-col items-center gap-1 ${className}`}>
      <div 
        className={`${sizeClass} relative rounded-full overflow-hidden bg-gray-700 flex items-center justify-center border-2 border-gray-600`}
        title={finalName}
      >
        {finalImageUrl && !imageError ? (
          <>
            {imageLoading && (
              <div className="absolute inset-0 bg-gray-700 animate-pulse flex items-center justify-center">
                <div className="w-3 h-3 bg-gray-500 rounded-full animate-bounce"></div>
              </div>
            )}
            <img
              src={finalImageUrl}
              alt={finalName || 'Jugador'}
              className="w-full h-full object-cover"
              onLoad={handleImageLoad}
              onError={handleImageError}
              loading="lazy"
            />
          </>
        ) : (
          <div className="flex items-center justify-center w-full h-full text-gray-300">
            {finalName ? (
              <span className="font-medium select-none">
                {getInitials(finalName)}
              </span>
            ) : (
              <FallbackIcon className={iconSizeClass} />
            )}
          </div>
        )}
      </div>
      
      {showName && finalName && (
        <span className="text-xs text-gray-300 text-center max-w-16 truncate">
          {finalName.split(' ')[0]}
        </span>
      )}
    </div>
  );
};

export default PlayerAvatar;